import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CoreService } from '../core/core.service';
import { EkubService } from './ekub.service';;
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-award-add',
  templateUrl: './award.add.component.html',
  styleUrls: ['./award.add.component.scss']
})

export class AwardAddComponent {

  award: any = {};
  isLoading: any;
  id: string;
  updateEkub: string;
  selectedEkub: any = {};
  message: string = 'Award 1';
  awardForm!: FormGroup;
  guaranteeForm!: FormGroup;
  config: any;
  operation: string;
  ekubs: any[];
  users: any[];
  userStats: any;
  winnerStats: any;
  ekubMembers: any = [];
  guarantees: any = [];
  totalGuaranteeAmount: number = 0;
  totalEkubs: number = 0;
  winnerBalance: number = 0;
  // File

  file: any;
  files: File[] = [];
  files_temp: any = [];
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;
  error: string;
  userId: number = 1;
  uploadResponse = { status: '', message: '', filePath: '' };

  guaranteeDTO: any = {};
  addUpdateGuarantee = false;

  constructor(private http: Http, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService,

    private imageCompress: NgxImageCompressService, private api: EkubService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.award = {
      ekub: null,
      winner: null,
      code: null,
      draw_date: null,
      type: null,
      guarantee_number: null,
      status: null,
      remark: null
    };
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
    }
    if (this.route.queryParams['value']['ekub']) {
      this.updateEkub = this.route.queryParams['value']['ekub'];
    }
    this.operation = !this.id ? 'add' : 'update';
  }

  get ekub() { return this.awardForm.get('ekub'); }
  get amount() { return this.awardForm.get('amount'); }
  get winner() { return this.awardForm.get('winner'); }
  get code() { return this.awardForm.get('code'); }
  get draw_date() { return this.awardForm.get('draw_date'); }
  get draw_time() { return this.awardForm.get('draw_time'); }
  get recieved_date() { return this.awardForm.get('recieved_date'); }
  //get type() { return this.awardForm.get('type'); }
  //get guarantee_ref_number() { return this.awardForm.get('guarantee_ref_number'); }
  get status() { return this.awardForm.get('status'); }
  get remark() { return this.awardForm.get('remark'); }


  get guarantee() { return this.guaranteeForm.get('guarantee'); }
  get gstatus() { return this.guaranteeForm.get('status'); }
  get gremark() { return this.guaranteeForm.get('remark'); }
  get type() { return this.guaranteeForm.get('type'); }
  get guarantee_ref_number() { return this.guaranteeForm.get('guarantee_ref_number'); }

  ngOnInit() {
    this.createForm();
    this.getAllEkubs("&status=active");
    if (this.id) {
      this.getAward();
    }
  }

  private createForm() {

    this.awardForm = this.formBuilder.group({
      ekub: ['', [Validators.required]],
      winner: [''],
      code: [''],
      draw_date: ['', [Validators.required,]],
      draw_time: ['',],
      recieved_date: [''],
      amount: [0],
      type: [''],
      guarantee_ref_number: [''],
      status: ['pending', Validators.required],
      remark: [''],
    });

    this.guaranteeForm = this.formBuilder.group({
      guarantee: ['', []],
      status: ['pending', Validators.required], // pending, active, released
      type: ['member', Validators.required],
      guarantee_ref_number: ['', Validators.required],
      remark: [''],
    });

  }

  toggleGuaranteeChange() {
    debugger;
    this.addUpdateGuarantee = !this.addUpdateGuarantee;
  }

  //Modified 
  getAward() {
    this.api.getAward(this.id, "?include=guarantees").subscribe((res: any) => {
      debugger;
      this.ekub.setValue(res.data.ekub.data.id);
      let date = res.data.draw_date.split(" ")[0];
      let times = res.data.draw_date.split(" ")[1];
      this.draw_date.setValue(date);
      this.draw_time.setValue(times);
      if (res.data?.recieved_date) {
        let _receive_date = res.data.recieved_date.split(" ")[0];
        this.recieved_date.setValue(_receive_date);
      }
      if (res.data?.winner?.data?.id) {
        this.winner.setValue(res.data.winner.data.id);
        this.code.setValue(res.data?.code);
        this.fetchWinnerStats(res.data.winner.data.id);
      } else {
        this.winner.setValue('');
      }
      this.status.setValue(res.data.status);
      this.amount.setValue(res.data.amount);
      this.remark.setValue(res.data.remark);
      this.getEkubMembers(res.data.ekub.data.id);

      /*    'guarantee_type': '',
         'guarantee_number': '',
         'status': '',
         'remark': '' */

    });
  }

  getWinnerStats() {

  }

  getAllEkubs(filter) {
    this.api.getAllEkubs(filter).subscribe((res: any) => {
      debugger;
      this.ekubs = res.data;
      for (let ekub of this.ekubs) {
        ekub.text = ekub.ekub_id + ' - ' + ekub.category.data.amount + ' ETB / ' + ekub.category.data.interval;
        ekub.id = ekub.id;
      }
    });
  }

  ekubSelected() {
    //this.amount = this.ekub.category.data.amount;
    return this.ekub.value;
  }
  getEkubMembers(ekubId: any = null) {
    debugger;
    const result = this.ekubs.filter(
      (ekub: any) => ekub.id.toLowerCase().indexOf((ekubId) ? ekubId.toLowerCase() : this.ekub.value.toLowerCase()) !== -1
    );
    this.selectedEkub = result[0];
    //this.selectedEkub.total_reward = this.selectedEkub.category.data.amount * this.selectedEkub.length;
    this.amount.setValue(this.selectedEkub.value);
    debugger;
    this.api.getEkubMembers((ekubId != null) ? ekubId : this.ekub.value).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }

  isOperationAdd(): boolean {
    return (this.operation == "add");
  }

  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  setEkub(ekub: any) {
    debugger;
  }


  addGuarantee() {
    debugger;
    if (this.ekub.value) {
      if (this.type.value == 'member') {
        if (this.userStats.total_balance <= 0) {
          this.mainService.toast({ title: 'Not enough balance', body: 'Selected Member does not have enough balance to be a guarantee!', type: 'danger' });
          return;
        } else if (this.totalGuaranteeAmount + this.winnerBalance >= 0) {
          this.mainService.toast({
            title: 'No need', body: 'Currently added guarantee covers the winner\'s debt!', type: 'info'
          });
          return;
        }
        else {
          this.guarantees.push({
            guarantee: this.guarantee.value,
            ref_number: this.guarantee_ref_number.value,
            status: this.gstatus.value,
            balance: this.userStats.total_balance,
            ekubs: this.userStats.ekubs.length,
            remark: this.gremark.value,
          });
        }
        this.totalEkubs += this.userStats.ekubs.length;
        this.totalGuaranteeAmount += this.userStats.total_balance;
      } else {
        this.guarantees.push({
          type: this.type.value,
          guarantee: "this.guarantee.value",
          ref_number: this.guarantee_ref_number.value,
          //amount_guaranteed: this.winnerBalance,
          status: this.gstatus.value,
          remark: this.gremark.value,
        });
      }
      this.guaranteeForm.reset();
    } else {
      this.mainService.toast({ title: 'Warning', body: 'Please Select Ekub First!', type: 'Warning' });

    }

  }

  removeGuarantee(index: number) {
    debugger;
    this.totalEkubs -= this.guarantees[index].ekubs;
    this.totalGuaranteeAmount -= this.guarantees[index].balance;
    this.guarantees.splice(index, 1);
  }
  addAward() {
    debugger;
    this.isLoading = !this.isLoading;
    this.award = this.awardForm.value;
    if (this.award.winner != '' && this.award.winner != null) {
      var mem = this.ekubMembers.filter(
        (member: any) => member.id.toLowerCase().indexOf(this.award.winner.toLowerCase()) !== -1
      )[0];
      this.award.code = mem.pivot.code;
    }
    this.award.draw_date = this.award.draw_date + ' ' + this.award.draw_time;
    this.award.guarantee = this.guarantees;
    this.api.createAward(this.award, this.id).subscribe((res: any) => {
      //this.api.createAward({ award: this.award, guarantee: this.guarantees }, this.id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      /*  TODO add guarantee independently if (this.files.length > 0) {
         this.uploadFile(res.data.id);
       } */
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Award successfully updated! ' : 'Award  successfully added!', type: 'dark' });
      this.router.navigate(['/awards']);
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });

  }


  saveGuarantee() {
    debugger;
    this.isLoading = !this.isLoading;
    this.guaranteeDTO = this.awardForm.value;
    this.guaranteeDTO.award = this.id;
    this.guaranteeDTO.guarantee_amount = this.winnerBalance;
    /* var mem = this.ekubMembers.filter(
      (member: any) => member.id.toLowerCase().indexOf(this.award.winner.toLowerCase()) !== -1
    )[0]; */
    //this.award.code = mem.pivot.code;
    //this.award.draw_date = this.award.draw_date + ' ' + this.award.draw_time;
    //this.guarantee.guarantee = this.guarantees;
    this.api.createGuarantee(this.guaranteeDTO, this.id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      /*  TODO add guarantee independently if (this.files.length > 0) {
         this.uploadFile(res.data.id);
       } */
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Guarantee successfully updated! ' : 'Guarantee  successfully added!', type: 'dark' });
      this.router.navigate(['/awards']);
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });

  }




  // File upload

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
    console.log(this.files);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
    console.log(this.files);

  }

  onFilesAdded(files: any) {
    let j = 0;
    this.files = files.addedFiles;
    console.log('this.files');
    console.log(this.files);
    for (let file of this.files) {
      if (j > 4) {
        break;
      }
      let fileName: any;
      fileName = file['name'];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.localUrl = event.target.result;
          this.compressFile(this.localUrl, fileName);
        }
        reader.readAsDataURL(file);
      }
      j++;
    }
  }

  compressFile(image: any, fileName: string) {
    var orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
    this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
        // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
        const imageName = fileName;
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
        this.files_temp.push(imageFile);
      });
    console.log('this.files_temp');
    console.log(this.files_temp);
  }


  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }


  public async uploadFile(id: any) {
    debugger;
    this.successUploadCount = 0;
    this.failedUploadCount = 0;
    /* for (let file of this.files) { */
    for (let file of this.files_temp) {
      console.log(file);
      const formData = new FormData();
      if (file instanceof File) {
        formData.append('file', file, file.name);
        formData.append('item_id', id);
        formData.append('designation', 'guarantee');
        this.uploading = true;
        await this.api.upload(formData, id).then((res: any) => {
          debugger;
          this.uploadResponse = res;
          console.log(res);
          if (this.uploadResponse.status !== 'progress' &&
            this.uploadResponse.status !== 'unhandeled event') {
            this.successUploadCount++;
            let temp = (this.successUploadCount / this.files.length) * 100;
            this.uploadResponse.message = temp.toString();
          }
        }, function (err) {
        });
      }

    }
    this.mainService.toast({ title: 'Success', body: (this.id) ? 'Award pictures successfully updated! ' : 'Award pictures successfully added!', type: 'dark' });
    this.router.navigate(['/awards'], { queryParams: { subject: 'post' } });

  }

  fetchUser(searchTerm: any) {
    debugger;
    console.log(searchTerm.target.value);
    if (searchTerm.target.value) {
      this.api.fetchUsers(searchTerm.target.value).subscribe((res: any) => {
        debugger;
        this.isLoading = !this.isLoading;
        this.users = res.data;
        for (let user of this.users) {
          user.text = user.username + ' - ' + user.email;
          user.id = user.id;
        }
      }, (err) => {
        debugger;
        err = err;
        this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: 'Could not fetch users!', type: 'danger' });
      });
    }

  }


  fetchWinnerStats(id: string) {
    debugger;
    this.winnerStats = null;
    this.api.getUserStats(id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.winnerStats = res.data;
      this.winnerBalance = Math.abs(this.winnerStats.total_balance);
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: 'Could not fetch winner stats!', type: 'danger' });
    });


  }

  fetchUserStats() {
    debugger;
    this.userStats = null;
    var searchTerm = this.guarantee.value;
    console.log(searchTerm);
    if (searchTerm) {
      this.api.getUserStats(searchTerm).subscribe((res: any) => {
        debugger;
        this.isLoading = !this.isLoading;
        this.userStats = res.data;
        if (this.userStats.total_balance <= 0) {
          this.mainService.toast({ title: 'Error', body: 'User doesn\'t have enough balance to be a guarantee. balance = ' + this.userStats.total_balance, type: 'danger' });
          this.guarantee.setValue(null);
        }
      }, (err) => {
        debugger;
        err = err;
        this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: 'Could not fetch users!', type: 'danger' });
      });
    }

  }

  checkValidity() {
    if (this.operation != "add") {
      if (this.type.value == "member" && (this.totalGuaranteeAmount < this.winnerBalance)) {
        return true;
      } else {
        return false;
      }
    }

  }

}
